<div class="hf-settings">
  <h3>{{ mode === 'header' ? 'Header Templates' : 'Footer Templates' }}</h3>
  <!-- <div style="margin:8px 0 12px;display:flex;gap:12px;align-items:center">
    <div *ngIf="mode==='header'" style="display:flex;gap:8px;align-items:center">
      <label style="min-width:70px">Header bg:</label>
      <input [attr.guide]="'header-footer-settings-inp-1' + '__' + sanitizeUrl(url)" type="color" [(ngModel)]="headerBg" />
      <label style="min-width:40px">Text:</label>
      <input [attr.guide]="'header-footer-settings-inp-2' + '__' + sanitizeUrl(url)" type="color" [(ngModel)]="headerColor" />
      <label style="min-width:40px">Line:</label>
      <input [attr.guide]="'header-footer-settings-inp-3' + '__' + sanitizeUrl(url)" type="checkbox" [(ngModel)]="lineEnabled" />
      <label style="min-width:40px">Thickness:</label>
      <input [attr.guide]="'header-footer-settings-inp-4' + '__' + sanitizeUrl(url)" type="number" min="0" style="width:64px" [(ngModel)]="lineThickness" />
      <label style="min-width:40px">Color:</label>
      <input [attr.guide]="'header-footer-settings-inp-5' + '__' + sanitizeUrl(url)" type="color" [(ngModel)]="lineColor" />
      <label style="min-width:60px">Position:</label>
      <mat-form-field appearance="outline" style="width:110px;margin-left:4px;">
        <mat-select [(value)]="linePosition">
          <mat-option value="top">Top</mat-option>
          <mat-option value="bottom">Bottom</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div *ngIf="mode==='footer'" style="display:flex;gap:8px;align-items:center">
      <label style="min-width:70px">Footer bg:</label>
      <input [attr.guide]="'header-footer-settings-inp-6' + '__' + sanitizeUrl(url)" type="color" [(ngModel)]="footerBg" />
      <label style="min-width:40px">Text:</label>
      <input [attr.guide]="'header-footer-settings-inp-7' + '__' + sanitizeUrl(url)" type="color" [(ngModel)]="footerColor" />
      <label style="min-width:40px">Line:</label>
      <input [attr.guide]="'header-footer-settings-inp-8' + '__' + sanitizeUrl(url)" type="checkbox" [(ngModel)]="lineEnabled" />
      <label style="min-width:40px">Thickness:</label>
      <input [attr.guide]="'header-footer-settings-inp-9' + '__' + sanitizeUrl(url)" type="number" min="0" style="width:64px" [(ngModel)]="lineThickness" />
      <label style="min-width:40px">Color:</label>
      <input [attr.guide]="'header-footer-settings-inp-10' + '__' + sanitizeUrl(url)" type="color" [(ngModel)]="lineColor" />
      <label style="min-width:60px">Position:</label>
      <mat-form-field appearance="outline" style="width:110px;margin-left:4px;">
        <mat-select [(value)]="linePosition">
          <mat-option value="top">Top</mat-option>
          <mat-option value="bottom">Bottom</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div> -->
  <div *ngIf="mode==='header'" style="margin-bottom:12px;padding:8px;border:1px solid #eee;border-radius:4px">
    <div style="display:flex;gap:12px;align-items:center">
      <div style="flex:0 0 auto">
        <input [attr.guide]="'header-footer-settings-inp-11' + '__' + sanitizeUrl(url)" type="file" accept="image/*" (change)="onLogoFile($event)" />
        <div *ngIf="logoSrc" style="margin-top:8px"><img [src]="logoSrc" style="height:48px;object-fit:contain" /></div>
      </div>
      <div style="flex:1;min-width:180px">
        <div style="display:flex;gap:8px;align-items:center">
          <label style="min-width:70px">Logo width:</label>
          <input [attr.guide]="'header-footer-settings-inp-12' + '__' + sanitizeUrl(url)" [(ngModel)]="logoWidth" placeholder="30% or 120px" />
        </div>
        <div style="margin-top:8px;display:flex;gap:8px">
          <label style="min-width:70px">Title:</label>
          <input [attr.guide]="'header-footer-settings-inp-13' + '__' + sanitizeUrl(url)" [(ngModel)]="headerTitle" style="flex:1" />
        </div>
        <div style="margin-top:8px;display:flex;gap:8px">
          <label style="min-width:70px">Subtitle:</label>
          <input [attr.guide]="'header-footer-settings-inp-14' + '__' + sanitizeUrl(url)" [(ngModel)]="headerSubtitle" style="flex:1" />
        </div>
        <div style="margin-top:8px"><button [attr.guide]="'header-footer-settings-btn-15' + '__' + sanitizeUrl(url)" mat-button color="primary" (click)="onSelect(buildLogoTitleHeaderHtml())">Insert Customized Header</button></div>
      </div>
      <div>
        
      </div>
    </div>
  </div>
  <div class="templates">
    <div class="template" *ngFor="let t of templates">
      <div class="preview" [innerHTML]="applyBg(t.html)"></div>
      <div class="meta">
        <div class="label">{{ t.label }}</div>
        <button [attr.guide]="'header-footer-settings-btn-16' + '__' + sanitizeUrl(url)" mat-button color="primary" (click)="onSelect(t.html)">Use</button>
      </div>
    </div>
  </div>
</div>
